import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { _setAxios } from '../../lib/Helper';

async function fetchList() {
  return await _setAxios("whatsapp/service/dropdown", "GET")
    .then(body => {
      let results = []
      body.data?.data?.forEach(row => {
        results.push({
          label: row.name,
          value: row.id,
        })
      });

      return results
    })

}

const SelectWhatsappService = ({ ...props }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetchList().then((newOptions) => {
      setOptions(newOptions);
    });
  }, []);

  return (
    <Select
      {...props}
      allowClear
      placeholder="Pilih service"
      style={{
        width: '100%',
      }}
      options={options}
    />
  );
};
export default SelectWhatsappService;
